import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PasswordModule } from 'primeng/password';
import { CardModule } from 'primeng/card';
import { TextareaModule } from 'primeng/textarea';
import { InputIcon } from 'primeng/inputicon';
import { IconField } from 'primeng/iconfield';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TabsModule } from 'primeng/tabs';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';

import { ServerSearchDirective } from '@card-software/nexus-utilities';

const modules = [
  ServerSearchDirective,
  AutoCompleteModule,
  ButtonModule,
  BreadcrumbModule,
  CardModule,
  CheckboxModule,
  FloatLabelModule,
  InputIcon,
  InputNumberModule,
  InputTextModule,
  IconField,
  MultiSelectModule,
  PaginatorModule,
  PasswordModule,
  SelectModule,
  SelectButtonModule,
  TagModule,
  TableModule,
  TabsModule,
  TextareaModule,
  ToastModule,
];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules],
})
export class PrimengModule {}
